import React from 'react'

import {
  RegisterOptions,
  FieldErrors,
  UseFormRegister,
  Path,
  FieldValues
} from 'react-hook-form'
import { ErrorMessage } from '@hookform/error-message'
import styles from '../shared.module.scss'
import { get } from '../../../../helpers/utils'

/* Saved for the future
https://www.thisdot.co/blog/how-to-create-reusable-form-components-with-react-hook-forms-and-typescript
 */

export type FormInputProps<TFormValues extends FieldValues> = {
  label: string
  name: Path<TFormValues>
  rules?: RegisterOptions<TFormValues, Path<TFormValues>>
  register?: UseFormRegister<TFormValues>
  errors?: FieldErrors<TFormValues>
} & React.DetailedHTMLProps<
  React.InputHTMLAttributes<HTMLInputElement>,
  HTMLInputElement
>

export const TextInput = <T extends FieldValues>({
  name,
  id,
  register,
  rules,
  errors,
  label,
  ...props
}: FormInputProps<T>): JSX.Element => {
  const errorMessages = get(errors, `${name}.message`, '')
  const hasError = !!(errors && errorMessages)

  return (
    <div className={styles.Container} aria-live='polite'>
      <label className={styles.Label} htmlFor={name}>
        {label}
      </label>
      <input
        type='text'
        id={id || name}
        name={name}
        aria-invalid={hasError}
        className={`${styles.Input} ${hasError ? styles.InvalidInput : ''}`}
        {...props}
        {...(register && register(name, rules))}
      />
      <ErrorMessage
        errors={errors}
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        name={name as any}
        render={({ message }) => (
          <p className={styles.ErrorMessage}>{message}</p>
        )}
      />
    </div>
  )
}
